import { toBengaliNumeral } from './bengaliHelpers'

export interface TransportOption {
  id: string
  type: 'bus' | 'uber' | 'cng' | 'rickshaw' | 'walking'
  name: string
  fareRange: [number, number]
  durationMinutes: number
  note?: string
  icon: string
}

export interface ShipSchedule {
  id: string
  operator: string
  departureTime: string
  arrivalTime: string
  duration: string
  price: number
  class: string
  availability: 'high' | 'medium' | 'low'
}

export const lastMileOptions: TransportOption[] = [
  {
    id: 'opt_bus',
    type: 'bus',
    name: 'লোকাল বাস',
    fareRange: [30, 40],
    durationMinutes: 60,
    note: 'ফার্মগেট হয়ে',
    icon: 'Bus',
  },
  {
    id: 'opt_uber',
    type: 'uber',
    name: 'উবার / পাঠাও',
    fareRange: [400, 500],
    durationMinutes: 30,
    note: 'এসি কার',
    icon: 'Car',
  },
  {
    id: 'opt_cng',
    type: 'cng',
    name: 'সিএনজি',
    fareRange: [200, 300],
    durationMinutes: 35,
    note: 'মিটার বা চুক্তি',
    icon: 'CarTaxiFront',
  },
  {
    id: 'opt_rickshaw',
    type: 'rickshaw',
    name: 'রিকশা',
    fareRange: [100, 120],
    durationMinutes: 45,
    note: 'শর্টকাট রাস্তা',
    icon: 'Bike',
  },
  {
    id: 'opt_walk',
    type: 'walking',
    name: 'হাঁটা',
    fareRange: [0, 0],
    durationMinutes: 120,
    note: 'স্বাস্থ্যকর',
    icon: 'Footprints',
  },
]

export const shipSchedules: ShipSchedule[] = [
  {
    id: 'ship_1',
    operator: 'এম ভি কর্ণফুলী ১০',
    departureTime: '০৮:০০',
    arrivalTime: '১২:৩০',
    duration: '৪ ঘণ্টা ৩০ মি',
    price: 350,
    class: 'ডেক',
    availability: 'high',
  },
  {
    id: 'ship_2',
    operator: 'গ্রীন লাইন ওয়াটার',
    departureTime: '০৯:৩০',
    arrivalTime: '১৩:০০',
    duration: '৩ ঘণ্টা ৩০ মি',
    price: 700,
    class: 'এসি চেয়ার',
    availability: 'medium',
  },
  {
    id: 'ship_3',
    operator: 'এম ভি ভোলা',
    departureTime: '১৪:০০',
    arrivalTime: '১৮:৩০',
    duration: '৪ ঘণ্টা ৩০ মি',
    price: 400,
    class: 'কেবিন (সিঙ্গেল)',
    availability: 'low',
  },
]

export const locations = [
  'বাংলামটর',
  'সদরঘাট',
  'ভোলা',
  'বরিশাল',
  'চট্টগ্রাম',
  'সিলেট',
  'কক্সবাজার',
]
